import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { useNavigate, useParams } from "react-router-dom";
import { membercloseloan, memberdeleteloan, memberlistindividualloan, memberlistloan } from "../../../services/admin";
import Swal from "sweetalert2";

export default function MemberLoan() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [filterProduct, setFilterProduct] = useState([]);
    const role = localStorage.getItem("Role");

    const hasGroupName = filterProduct?.some(row => row.group_name);
    const columnDefs = [
        ...(role == 1 || role == 2
            ? [
                {
                    headerName: "Actions",
                    field: "loanid",
                    width: 150,
                    sortable: true,
                    resizable: true,
                    filter: false,
                    floatingFilter: false,
                    cellStyle: { textAlign: "left" },
                    cellRenderer: function (params) {
                        if (params.data.loan_closed != 0 && params.data.loan_closed != 3) {
                            return (
                                <div className="text-center">
                                    <a className="btn-sm btn-warning me-2" title="Close Loan" onClick={() => closeloan(params.value)}>
                                        <i className="fa fa-close"></i>
                                    </a>
                                    <a className="btn-sm btn-danger me-2" title="Delete Loan" onClick={() => deleteloan(params.value)}>
                                        <i className="fa fa-trash"></i>
                                    </a>
                                </div>
                            );
                        } else if (params.data.loan_closed == 3) {
                            return (
                                <div className="text-center text-danger">
                                    <span className="me-2">Loan Closed</span>

                                    <a className="btn-sm btn-danger" title="Delete Loan" onClick={() => deleteloan(params.value)}>
                                        <i className="fa fa-trash"></i>
                                    </a>
                                </div>
                            );
                        }

                    },
                },
            ]
            : []),

        {
            headerName: "Scheme ID",
            field: "scheme_id",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Total Dues",
            field: "no_of_dues",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        ...(hasGroupName
        ? [ {
            headerName: "Group Name",
            field: "group_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        }] : []),
       
        {
            headerName: "Member Name",
            field: "member_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Loan Amount",
            field: "total_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Paid Due",
            field: "paiddue",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Pending Due",
            field: "pendingdue",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Total Amount",
            field: "overall_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Amount Paid",
            field: "total_paid",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Staff",
            field: "staff_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

    ];

    useEffect(() => {
        funlist();
    }, []);

    function funlist() {
        setFilterProduct([]);
        // memberlistloan(id).then((res) => {
        //     if (res.status === true) {
        //         setFilterProduct(res.data.details);
        //     }
        // })

        // memberlistindividualloan(id).then((res) => {
        //     if (res.status === true) {
        //         setFilterProduct(res.data.details);
        //     }
        // })
        Promise.all([memberlistloan(id), memberlistindividualloan(id)])
            .then(([resLoan, resIndividual]) => {
                const combinedData = [];

                if (resLoan.status === true) {
                    combinedData.push(...resLoan.data.details);
                }

                if (resIndividual.status === true) {
                    combinedData.push(...resIndividual.data.details);
                }

                setFilterProduct(combinedData);
            })
            .catch((err) => {
                console.error("Error fetching loan data:", err);
            });
    }
    function closeloan(cid) {
        Swal.fire({
            text: "Are you sure want to close loan?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Yes",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                membercloseloan(cid).then((res) => {
                    if (res.status === true) {
                        funlist();
                    }
                })
            }
        });
    }
    function deleteloan(cid) {
        Swal.fire({
            title: "Are you sure want to delete loan?",
            text: "If loan is deleted then all dues will be deleted, you cannot retrieve the loan.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Yes",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                memberdeleteloan(cid).then((res) => {
                    if (res.status === true) {
                        funlist();
                    }
                })
            }
        });
    }
    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Members Loan</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Members</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Members Loan
                    </li>
                </ol>
            </div>


            <div className="content-body">
                <div className="row">
                    <div className="col-md-12 text-right">
                        <a className="btn btn-danger mb-2" onClick={() => navigate(`/member/allmembers`)}>Back</a>
                    </div>
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    Member Loan List
                                </h2>
                            </div>
                            <div className="card-body">

                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={filterProduct}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
